// Split "Jul 2023 – Present · Hamilton, NJ" => { dateText: "Jul 2023 – Present", location: "Hamilton, NJ" }
export function splitPeriod(period = "") {
  const [range, loc] = (period || "").split("·").map((s) => s.trim());
  return { dateText: range || period || "", location: loc || "" };
}

// Dev-time tests (won't run in production)
if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production") {
  const cases = [
    ["Jul 2023 – Present · Hamilton, NJ", "Jul 2023 – Present", "Hamilton, NJ"],
    ["May 2013 – Jun 2014 · New York, NY", "May 2013 – Jun 2014", "New York, NY"],
    ["Oct 2004 – Oct 2008 · Camp Pendleton, CA", "Oct 2004 – Oct 2008", "Camp Pendleton, CA"],
    ["2012 – 2013", "2012 – 2013", ""],
    ["", "", ""],
  ];
  cases.forEach(([input, expDate, expLoc], i) => {
    const { dateText, location } = splitPeriod(input);
    console.assert(dateText === expDate, `[splitPeriod] case ${i} dateText '${dateText}' !== '${expDate}'`);
    console.assert(location === expLoc, `[splitPeriod] case ${i} location '${location}' !== '${expLoc}'`);
  });
}
